export const augustUppercase = "dra";
export default {augustUppercase};